document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-posts-listing]').forEach((root) => {
        if (root.dataset.postsReady === '1') {
            return;
        }
        root.dataset.postsReady = '1';

        const perPage = Math.max(1, Number(root.dataset.perPage || 9));
        const cards = Array.from(root.querySelectorAll('[data-posts-card]'));
        const filters = Array.from(root.querySelectorAll('[data-posts-filter]'));
        const statusNodes = Array.from(root.querySelectorAll('[data-posts-status]'));
        const prevBtns = Array.from(root.querySelectorAll('[data-posts-prev]'));
        const nextBtns = Array.from(root.querySelectorAll('[data-posts-next]'));
        const paginations = Array.from(root.querySelectorAll('[data-posts-pagination]'));

        if (!cards.length) {
            return;
        }

        let activeCategory = 'visi';
        let currentPage = 0;

        const getFilteredCards = () =>
            cards.filter((card) => {
                if (activeCategory === 'visi') {
                    return true;
                }
                return card.getAttribute('data-category') === activeCategory;
            });

        const update = () => {
            const filtered = getFilteredCards();
            const totalPages = Math.max(1, Math.ceil(filtered.length / perPage));
            const showPagination = filtered.length > 0 && totalPages > 1;

            if (currentPage > totalPages - 1) {
                currentPage = totalPages - 1;
            }
            if (currentPage < 0) {
                currentPage = 0;
            }

            cards.forEach((card) => {
                card.classList.remove('is-visible');
                card.setAttribute('hidden', '');
            });

            filtered.forEach((card, index) => {
                const page = Math.floor(index / perPage);
                card.setAttribute('data-page', String(page));

                if (page === currentPage) {
                    card.classList.add('is-visible');
                    card.removeAttribute('hidden');
                }
            });

            const label = `${currentPage + 1}/${totalPages}`;
            statusNodes.forEach((node) => {
                node.textContent = label;
            });

            paginations.forEach((node) => {
                node.hidden = !showPagination;
            });

            const atStart = currentPage <= 0;
            const atEnd = currentPage >= totalPages - 1;

            prevBtns.forEach((btn) => {
                btn.disabled = atStart;
            });
            nextBtns.forEach((btn) => {
                btn.disabled = atEnd;
            });
        };

        filters.forEach((btn) => {
            btn.addEventListener('click', () => {
                activeCategory = btn.getAttribute('data-posts-filter') || 'visi';
                currentPage = 0;

                filters.forEach((item) => {
                    const active = item === btn;
                    item.classList.toggle('is-active', active);
                    item.setAttribute('aria-selected', active ? 'true' : 'false');
                });

                update();
            });
        });

        prevBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
                currentPage -= 1;
                update();
            });
        });

        nextBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
                currentPage += 1;
                update();
            });
        });

        update();
    });
});
